import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { AutomotiveAftermarketEndpoint } from './constants/automotive-aftermarket-endpoint';
import { AutomotiveAftermarketCard } from './automotive-aftermarket-list.state';
import { AutomotiveAftermarketListRequestModel } from './models/automotive-aftermarket-list-filters.model';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketListService {
  constructor(private http: WrapperHttpService) {}

  getAutomotiveAftermarketList({
    size,
    page,
    ...filter
  }: Partial<AutomotiveAftermarketListRequestModel>): Observable<AutomotiveAftermarketCard> {
    const url = `${API_URL}${AutomotiveAftermarketEndpoint.Base}`;
    return this.http.withLoading().post<AutomotiveAftermarketCard>(url, { size, page, filter });
  }
}
